import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = '/configuracion/bitacora/';

/**
 * Obtiene el historial de auditoría global con filtros y paginación
 * @param {object} params
 * @returns {Promise<object>}
 */
export const getBitacoraGlobal = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return { results: [], count: 0 };
};

/**
 * Exporta a Excel TODAS las filas que cumplen los filtros (sin paginar),
 * generado en el servidor. Devuelve `{ blob, error }`: `blob` listo para
 * descargar si tuvo éxito, o `error` con el mensaje del backend (p. ej. "hay
 * demasiados registros, acote el filtro") si fue rechazado.
 * @param {object} params
 * @returns {Promise<{blob: Blob|null, error: string|null}>}
 */
export const exportarBitacoraGlobal = async (params) => {
  try {
    const response = await API.get(`${baseURI}exportar/`, {
      params,
      responseType: 'blob',
    });
    return { blob: response.data, error: null };
  } catch (err) {
    let detail = 'No se pudo generar la exportación.';
    const errData = err?.response?.data;
    if (errData instanceof Blob) {
      try {
        detail = JSON.parse(await errData.text())?.detail || detail;
      } catch {
        // Mantener el mensaje genérico si el cuerpo del error no es JSON.
      }
    } else if (errData?.detail) {
      detail = errData.detail;
    }
    return { blob: null, error: detail };
  }
};

/**
 * Obtiene el historial específico de un objeto por modelo y ID
 * @param {string} modelo
 * @param {number|string} objectId
 * @returns {Promise<object[]>}
 */
export const getHistorialPorObjeto = async (modelo, objectId) => {
  try {
    const response = await API.get(`${baseURI}historial-objeto/`, {
      params: {
        modelo,
        object_id: objectId,
      },
    });
    return response.data || [];
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * Obtiene los modelos registrados en el sistema de auditoría
 * @returns {Promise<object[]>}
 */
export const getModelosAuditados = async () => {
  try {
    const response = await API.get(`${baseURI}modelos-auditados/`);
    return response.data || [];
  } catch (err) {
    onError(err);
  }
  return [];
};
